// Codex product UX fixes 2026-06-03
(function () {
  var blockedHosts = [
    'otlp-http-production.shopifysvc.com',
    'monorail-edge.shopifysvc.com',
  ];

  function isBlockedTelemetryUrl(value) {
    var url = '';
    try {
      if (typeof value === 'string') {
        url = value;
      } else if (value && typeof value.url === 'string') {
        url = value.url;
      } else if (value && value.href) {
        url = String(value.href);
      }
    } catch (error) {
      return false;
    }
    return blockedHosts.some(function (host) {
      return url.indexOf(host) !== -1;
    });
  }

  if (!window.FmfShopifyTelemetryBlockerInstalled) {
    window.FmfShopifyTelemetryBlockerInstalled = true;

    if (navigator.sendBeacon) {
      var nativeSendBeacon = navigator.sendBeacon.bind(navigator);
      navigator.sendBeacon = function (url, data) {
        if (isBlockedTelemetryUrl(url)) return true;
        return nativeSendBeacon(url, data);
      };
    }

    if (window.fetch) {
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        if (isBlockedTelemetryUrl(input)) {
          return Promise.resolve(new Response(null, { status: 204, statusText: 'No Content' }));
        }
        return nativeFetch(input, init);
      };
    }
  }

  if (!document.querySelector('style[data-codex-pagespeed-modal-fix-20260630]')) {
    var style = document.createElement('style');
    style.setAttribute('data-codex-pagespeed-modal-fix-20260630', '');
    style.textContent = '.product-media-modal:not([open]) .product-media-modal__content>img{display:none!important}.product-media-modal .product-media-modal__content>img{overflow:clip!important}';
    document.head.appendChild(style);
  }
})();

(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var descriptionImages = document.querySelectorAll('.product__description img, .rte img.fmf-description-lightbox-trigger');
    descriptionImages.forEach(function (img, index) {
      if (!img.hasAttribute('loading')) img.loading = 'lazy';
      img.decoding = 'async';
      img.fetchPriority = 'low';
      if (!img.getAttribute('alt')) {
        var title = document.querySelector('.product__title h1, h1')?.textContent?.trim();
        img.setAttribute('alt', title ? title + ' detail image ' + (index + 1) : 'Product detail image ' + (index + 1));
      }
      if (!img.getAttribute('width') && img.naturalWidth) img.setAttribute('width', img.naturalWidth);
      if (!img.getAttribute('height') && img.naturalHeight) img.setAttribute('height', img.naturalHeight);
    });
  });
})();
// codex-quote-country-hide-soldout-20260615
(function () {
  var directCheckoutCountries = [
    'AT', 'AU', 'BE', 'BG', 'CA', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR',
    'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'JP', 'LT', 'LU', 'LV', 'MC', 'MT',
    'MX', 'MY', 'NL', 'NZ', 'PL', 'PT', 'RO', 'SA', 'SE', 'SG', 'SI', 'SK',
    'TH', 'US', 'VN'
  ];

  function isQuoteCountry() {
    var country = window.Shopify && window.Shopify.country;
    return country && directCheckoutCountries.indexOf(country) === -1;
  }

  function hideQuoteCountrySoldOutBadges(root) {
    if (!isQuoteCountry()) return;
    (root || document).querySelectorAll('.card__badge').forEach(function (badge) {
      if ((badge.textContent || '').trim() === 'Sold out') {
        badge.style.display = 'none';
        badge.setAttribute('data-codex-quote-country-hidden', 'true');
      }
    });
  }

  function initQuoteCountrySoldOutGuard() {
    if (!isQuoteCountry()) return;
    hideQuoteCountrySoldOutBadges(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('.card__badge')) hideQuoteCountrySoldOutBadges(node.parentElement);
          else if (node.querySelector('.card__badge')) hideQuoteCountrySoldOutBadges(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuoteCountrySoldOutGuard, { once: true });
  } else {
    initQuoteCountrySoldOutGuard();
  }
})();


